// extracted by mini-css-extract-plugin
export var statItem = "_gv-1";
export var statsRow = "_gv-0";